/**
 * Returns the locale in the format 'en-GB' if the locale is 'en',
 * as that's the default lang for the apps, otherwise returns the locale.
 * @param locale
 * @returns
 */
export const getIntlLocale = (locale: string) =>
  locale === 'en' ? 'en-GB' : locale;
